import { LocalizationContext } from 'app/localization/Context';
import React, { useState, useMemo, useCallback, useContext } from 'react';
import { toEnglishNumber } from '../NumberInputHelper';

import './InputCode.scss'


export default function InputCode({ keyPrefix, numberOfItems, codeVlaueCallback, marginTop }) {
    const l = useContext(LocalizationContext);

    const [code, setCode] = useState("");

    const onTypeCode = useCallback((e) => {
        let _code = e.target.value.slice(0, numberOfItems);
        setCode(l.localizeNumber(_code));
        codeVlaueCallback(toEnglishNumber(_code));
    }, [l, numberOfItems, codeVlaueCallback])

    const itemValues = useMemo(() => {
        const result = [];
        for (let i = 0; i < numberOfItems; i++) {
            if (i < code.length) {
                result.push(code[i]);
            } else {
                result.push("");
            }
        }
        return result;
    }, [numberOfItems, code]);

    return (
        <div className="input-code" style={{marginTop: marginTop}}>
            {itemValues.map((value, index) =>
                <div className="item"
                    key={keyPrefix + "-" + String(index)}>
                    <div className="value">{value}</div>
                </div>)}

            <input className="input-box" type="tel" value={code} onChange={onTypeCode}></input>
        </div>
    );
}